/**
 * Firebase Auth Providers - Production configuration
 * Firebase Web SDK v11.10.0 (modular v9+)
 * 
 * Primary: Google
 */
import { 
  GoogleAuthProvider, 
  signInWithPopup,
  signInWithRedirect,
  getRedirectResult
} from "firebase/auth";
import { auth } from "./config";
import { logger } from "../utils/logger";

// Provider configurations
const providers = {
  google: {
    id: 'google',
    name: 'Google',
    enabled: true,
    create: (forceAccountSelect = false) => {
      const provider = new GoogleAuthProvider();
      provider.addScope('email');
      provider.addScope('profile');
      if (forceAccountSelect) {
        // Wymusza wybór konta Google
        provider.setCustomParameters({ prompt: 'select_account' });
      }
      return provider;
    }
  }
};

/**
 * Get list of enabled providers
 */
export const getEnabledProviders = () => {
  return Object.values(providers).filter(p => p.enabled);
};

/**
 * Sign in with Google
 * @param {boolean} forceAccountSelect - wymusza wybór konta (dla "Zaloguj innym kontem")
 */
export const signInWithGoogle = async (forceAccountSelect = false) => {
  if (!auth) {
    throw new Error('Firebase not initialized');
  }
  
  const provider = providers.google.create(forceAccountSelect);
  
  try {
    // Try popup first (works on desktop)
    const result = await signInWithPopup(auth, provider);
    return result;
  } catch (error) {
    // Fallback to redirect for popup blockers or mobile
    if (error.code === 'auth/popup-blocked' || 
        error.code === 'auth/popup-closed-by-user' ||
        error.code === 'auth/cancelled-popup-request') {
      logger.log('[Firebase] Popup blocked, using redirect');
      await signInWithRedirect(auth, provider);
      return null;
    }
    throw error;
  }
};

/**
 * Check for redirect result (called on app load)
 */
export const checkRedirectResult = async () => {
  if (!auth) return null;
  
  try {
    const result = await getRedirectResult(auth);
    return result;
  } catch (error) {
    logger.error('[Firebase] Redirect result error:', error);
    return null;
  }
};

export default providers;
